// @ts-check
import { z } from 'zod';

const Usage = z.object({
  envelopes_to_send: z.number(),
  allowed_to_send: z.boolean(),
  envelopes_available_on_plan: z.number(),
  overages_required: z.number(),
  overages_cost: z.number(),
  overages_enabled: z.boolean(),
});

export default Usage;
